export default {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  setGroups(state, payload) {
    if(payload.groups !== undefined && payload.groups !== null) {
      state.groups = payload.groups
    } else {
      state.groups = []
    }
  },
  setZones(state, payload) {
    if(payload.zones !== undefined && payload.zones !== null) {
      state.zones = payload.zones
    } else {
      state.zones = []
    }
  },
  setPoles(state, payload) {
    if(payload.poles !== undefined && payload.poles !== null) {
      state.poles = payload.poles
    } else {
      state.poles = []
    }
  },
  setBuildings(state, payload) {
    if(payload.buildings !== undefined && payload.buildings !== null) {
      state.buildings = payload.buildings
    } else {
      state.buildings = []
    }
  },
  updateBuildings(state, payload) {
    for(var building of state.buildings) {
      if(building.devices) for(var device of building.devices) {
        if(device.id == payload.device) {
          if(payload.event == 'armed') device.armed = true
          else if(payload.event == 'disarmed') device.armed = false
          for(var key of Object.keys(payload)) {            
            if(device[key] !== undefined) {              
              device[key] = payload[key]
            }
          }
        }
      }
    }
    console.log('updateBuildings', payload)
  },
  setTags(state, payload) {
    if(payload.tags !== undefined && payload.tags !== null) {
      state.tags = payload.tags
    } else {
      state.tags = []
    }
  },
  setCurrentDevice (state, payload) {
    if (typeof payload !== "undefined") {
      state.currentDevice = payload;
    }
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}
